import React from 'react'
import { connect } from 'react-redux'
import {toArray} from "../helpers/objectLiteralToArray";
import {ROUTES_BY_ID} from "../constants/routes";
import {Link} from "./Link";

const vendorMenuOptions = {
    canon: {
        label: 'canon',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'canon/i-sensys-projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'canon/i-sensys-products'
            },
        }
    },
    hp: {
        label: 'hp',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'hp/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'hp/products'
            },
            customers: {
                label: "Klienci",
                link: 'customers'
            },
        }
    },
    epson: {
        label: 'epson',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'epson/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'epson/products'
            },
        }
    },
    lexmark: {
        label: 'lexmark',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'lexmark/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'lexmark/products'
            },
        }
    },
    lenovo: {
        label: 'lenovo',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'lenovo/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'lenovo/products'
            },
        }
    },
    jabra: {
        label: 'jabra',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'jabra/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'jabra/products'
            },
        }
    },
    xerox: {
        label: 'xerox',
        menu: {
            canonProjects: {
                label: "Projekty",
                link: 'xerox/projects'
            },
            canonProducts: {
                label: "Produkty",
                link: 'xerox/products'
            },
        }
    },
}

class HeadMenu extends React.Component {
	constructor (props) {
		super(props); //w propsach mamy type = typ menu potencjalnie mozemy tego użyć do innych rzeczy
		this.state = {
			loading: false,
            isError: false,
			menu: (SSR_DATA  && SSR_DATA.HeadMenu) ? SSR_DATA.HeadMenu : {}
		};
		this.handleOnClick = this.handleOnClick.bind(this);
		this.handleMouseEnter = this.handleMouseEnter.bind(this);
		this.handleMouseLeave = this.handleMouseLeave.bind(this);
    }

    componentDidMount() {
		this.loadData();
	}

	static async  fetchData() {
	    return {
	        home: {
                label: 'home',
                link: ''
            },
        }
    }

	async loadData()  {
        // if ( Object.keys(this.state.menu).length > 0) return;

        try {
            const menu = await HeadMenu.fetchData();
            this.setState({ menu })
        } catch (ex) {
            this.setState({isError: true})
        }
	}
    /**
     * parsuje string z url pod katem bledu, gdzie '-' wystaepuje zamiast '/' po nazwie strefy, a przed numerem strefy
     */
	parseUrl(url) {
	    if (typeof url === "undefined") {
	        return "#";
        }
	    let index = url.indexOf('-');
	    if((index+1) > url.length-1) {
	        return url;
        }
	    let n = url.charAt(index+1);

	    if (n >= '0' && n <= '9') {
            return url.substring(0, index) + '/' + url.substring(index+1);
        }
	    return url;
    }

	generateMenuItem(menu_item, index, depth) {
        let item_class_name;
	    if (depth === 0) {
            item_class_name = "nav-item navbar-dropdown-item";
        } else {
	        item_class_name = "nav-item submenu-dropdown-item"
        }

        console.error("aaa: ", menu_item);

        if (!menu_item) {
            return null;
        }

	    if (!menu_item.menu) {
	        let to = '';
	        if (menu_item.link) {
                to = '/' + this.parseUrl(menu_item.link);
            } else if (menu_item.id) {
                to = ROUTES_BY_ID[menu_item.id].path;
                let re = /\/:.*\?/;
                to = to.replace(re, '');
            }

	        if (depth === 0) {
                return <li onClick={this.handleOnClick}
                           onMouseLeave={this.handleMouseLeave}
                           onMouseEnter={this.handleMouseEnter}
                           key={index}
                           className={item_class_name}
                    >
                        <Link style={{display: 'inline'}} to={to}>{menu_item.label}</Link>
                    </li>
            } else {
                return <li onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
                           onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}>
                    <Link to={to}>{menu_item.label}</Link></li>;
            }
        } else if (menu_item.menu) {
            return this.generateSubmenu(menu_item, index, depth, item_class_name);
	    } else {

        }
    }

    generateSubmenu(menu_item, index, depth, item_class_name) {
        let result = [];
        let that = this;

        if (!menu_item) {
            return null;
        }

        if (menu_item.menu) {
            toArray(menu_item.menu).forEach((element, index) => {
                result.push(that.generateMenuItem(element, index, depth + 1));
            });
        } else {
            result = <li></li>;
        }
        let  elem_style;
        if (depth == 0) {
            //styles for first dropdown
            elem_style = {
                fontFamily: "'Rubik', sans-serif",
                fontWeight: 500,
                textAlign: "left",
                marginLeft: -1 + 'em',
                paddingLeft: 0,
                minWidth: 15 + 'em',
                lineHeight: 2.67,
                borderTop: "solid #33323a 11px",
                boxShadow: "rgba(0, 0, 0, 0.1) 8px 5px 20px -5px",
            };
        } else {
            //styles for futher 'dropright' menus
            elem_style = {
                fontWeight: 400,
                textAlign: "left",
                marginLeft: 17 + 'em',
                marginTop: -3.15 + 'em',
                paddingLeft: 0,
                lineHeight: 1.33,
                borderTop: "none",
                boxShadow: "10px 15px 40px 0 rgba(140, 138, 155, 0.2)",
                padding: '1rem .5rem',
                position: 'absolute',
                zIndex: '-1'
            };
        }
        let span ='';
        if (depth == 0) {
            span = <span style={{position: 'relative', zIndex: "999"}}>{menu_item.label}</span>;
        } else {
            span = <span>{menu_item.label}</span>;
        }
        if(menu_item.link) {
            return <li onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
                       onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}>
                <Link to={'/' + this.parseUrl(menu_item.link)}>{menu_item.label}</Link>
                <ul style={elem_style} className="dropdown-sublist">{result}
                </ul>
            </li>;
        } else {
            return <li onClick={this.handleOnClick} onMouseLeave={this.handleMouseLeave}
                       onMouseEnter={this.handleMouseEnter} key={index} className={item_class_name}>{span}
                <ul style={elem_style} className="dropdown-sublist">{result}
                </ul>
            </li>;
        }
    }

	generateMenu(menu) {
        if (!menu || typeof menu !== 'object') {
            return null;
        }

        return Object.keys(menu)
            .filter(name => menu[name])
            .map((name, index) => this.generateMenuItem(menu[name], index, 0));
	}

	handleOnClick(event) {
        document.querySelectorAll("li.item-hoovered").forEach((element) => {
           element.classList.remove('item-hoovered');
        });
    }

    handleMouseEnter(event) {
	    event.currentTarget.classList.add('item-hoovered');
    }
    handleMouseLeave(event) {
        event.currentTarget.classList.remove('item-hoovered');
    }

	render() {

        const { menu, loading } = this.state;

        if (!menu || loading) return null;

        let finalMenu = { ...menu };

        const allowedVendors = this.props.user?.privileges?.allowedVendors;

        if (Array.isArray(allowedVendors)) {
            allowedVendors.forEach(vendor => {
                const key = typeof vendor === 'string' ? vendor.toLowerCase() : null;
                const vendorMenu = key ? vendorMenuOptions[key] : null;

                if (!vendorMenu) {
                    console.warn('Missing vendor menu:', { vendor, key });
                    return;
                }

                finalMenu[vendor] = vendorMenu;
            });
        }

        return this.generateMenu(finalMenu);
	}
}

const mapStateToProps = (state) => {
    return { user: state.user }
}

export default connect(mapStateToProps)(HeadMenu)
